module.exports = __webpack_public_path__ + "img/dot-toggle.6ba40601.svg";